var React = require('react');

function Loader6 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1_353)","key":0},[React.createElement("rect",{"width":"90","height":"10","fill":"white","key":0}),React.createElement("rect",{"y":"20","width":"90","height":"10","fill":"white","key":1}),React.createElement("rect",{"y":"40","width":"90","height":"10","fill":"white","key":2}),React.createElement("rect",{"y":"60","width":"90","height":"10","fill":"white","key":3}),React.createElement("rect",{"y":"80","width":"90","height":"10","fill":"white","key":4}),React.createElement("rect",{"y":"100","width":"90","height":"10","fill":"white","key":5})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1_353"},React.createElement("rect",{"width":"90","height":"110","fill":"white"})))]);
}

Loader6.defaultProps = {"width":"90","height":"110","viewBox":"0 0 90 110","fill":"none"};

module.exports = Loader6;

Loader6.default = Loader6;
